import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';

import { PatientNavbarModule } from '../../../navbar/patient-navbar.module';
import { NextAppointmentModalComponent } from './next-appointment-modal.component';

@NgModule({
  declarations: [NextAppointmentModalComponent],
  exports: [NextAppointmentModalComponent],
  imports: [
    CommonModule,
    BsDatepickerModule,
    TimepickerModule,
    FormsModule,
    NgxBootstrapIconsModule,
    PatientNavbarModule,
  ],
})
export class NextAppointmentModalModule {}
